import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "noBorder"];
import React from 'react';
import cn from 'classnames';
import Block from '../Block1';
import './index.less';
export default function RowBlockTitle(props) {
  const {
    className,
    children,
    noBorder
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Block, _extends({
    className: cn('cc-row-block-title', className),
    titleClass: noBorder ? '' : 'hair-line hair-line--b'
  }, rest), children);
}